import {
  BlockConfig,
  zeroIOPS,
  OperationTypes,
  ContentTypes,
  Block,
  IOPS,
  multiplyIOPS,
} from "../block-base";
import { BlockTypes } from "../block-types";

export const lambdaSideEffects = (block: Block, iops: IOPS): Block => {
  let finalBlock = { ...block };
  let finalDynamicProperties = finalBlock.dynamicProperties || { "scale-count": 1 };

  // Base capacity per instance (defined in config)
  const baseConfig = lambdaConfig;
  const baseCapacityTotal = baseConfig.inputCapacity.total;

  const currentLoad = iops.total;

  // Calculate needed instances.
  // e.g. if load is 2500 and base is 1000, we need ceil(2.5) = 3 instances.
  let scaleCount = Math.ceil(currentLoad / baseCapacityTotal);
  if (scaleCount < 1) scaleCount = 1; // Minimum 1 instance

  finalDynamicProperties["scale-count"] = scaleCount;
  finalBlock.dynamicProperties = finalDynamicProperties;

  // Update capacities
  finalBlock.inputCapacity = multiplyIOPS(baseConfig.inputCapacity, scaleCount);
  finalBlock.processingCapacity = multiplyIOPS(baseConfig.processingCapacity, scaleCount);

  // Update cost per cycle
  // Cost scales linearly with the number of instances
  finalBlock.costPerCycle = baseConfig.costPerCycle * scaleCount;

  return finalBlock;
};

export const lambdaConfig: BlockConfig = {
  displayName: "Lambda",
  imagePath: "",
  isInitiator: true,
  isTerminator: true,
  isInterceptor: false,
  allowedInputTypes: new Set([
    BlockTypes.USER,
    BlockTypes.AUTO_SCALING_GROUP,
    BlockTypes.LOAD_BALANCER,
    BlockTypes.NETWORK_LOAD_BALANCER,
    BlockTypes.APP_SERVER,
    BlockTypes.LAMBDA,
    BlockTypes.QUEUE,
    BlockTypes.PASSTHROUGH,
  ]),
  allowedOutputTypes: new Set([
    BlockTypes.APP_SERVER,
    BlockTypes.LAMBDA,
    BlockTypes.DB_READ_REPLICA,
    BlockTypes.DATABASE,
    BlockTypes.AUTO_SCALING_GROUP,
    BlockTypes.LOAD_BALANCER,
    BlockTypes.NETWORK_LOAD_BALANCER,
    BlockTypes.QUEUE,
    BlockTypes.GRAPH_DB,
    BlockTypes.DOCUMENT_DB,
    BlockTypes.S3_BUCKET,
    BlockTypes.PASSTHROUGH,
  ]),
  inputCapacity: {
    total: 1500,
    byOperationType: {
      [`${OperationTypes.READ}`]: {
        total: 900,
        byContentType: {
          [`${ContentTypes.DYNAMIC}`]: 300,
          [`${ContentTypes.STATIC}`]: 300,
          [`${ContentTypes.STATIC_MEDIA}`]: 300,
        },
      },
      [`${OperationTypes.WRITE}`]: {
        total: 600,
        byContentType: {
          [`${ContentTypes.DYNAMIC}`]: 400,
          [`${ContentTypes.STATIC_MEDIA}`]: 200,
        },
      },
    },
  },
  processingCapacity: zeroIOPS(),
  purchasePrice: 500,
  sellPrice: 250,
  costPerCycle: 2,
  outputConnectorLimits: {},
  blockSideEffects: (block: Block, iops: IOPS) => lambdaSideEffects(block, iops),
};
